import { Entity } from "@backstage/catalog-model";
import { CatalogClient } from "@backstage/catalog-client";
import { discoveryApiRef, useApi } from "@backstage/core";
import { useEffect, useState } from "react";
import { identityApiRef } from "@backstage/core-plugin-api";

export const JIRA_PROJECT_KEY = "jira/project-key";
export const JIRA_PORTAL = "jira/portal";

export const useProjectEntity = (entity: Entity) => {
  const owner = entity.spec?.owner;

  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const ownerRef = `Group:default/${owner}`;
  const [ownerProjectKey, setOwnerProjectKey] = useState<string>("");
  const [portal, setPortal] = useState<string>();

  useEffect(() => {
    (async () => {
      const { token } = await identityApi.getCredentials();
      const catalog = new CatalogClient({ discoveryApi });
      const ownerEntity = await catalog.getEntityByRef(ownerRef, { token });

      setPortal(ownerEntity?.metadata?.annotations?.[JIRA_PORTAL]);
      setOwnerProjectKey(
        ownerEntity?.metadata?.annotations?.[JIRA_PROJECT_KEY] as string
      );
    })();
  }, [discoveryApi, ownerRef, identityApi, setOwnerProjectKey]);

  const overrideAnnotation = entity.metadata?.annotations?.[
    JIRA_PROJECT_KEY
  ] as string;

  return {
    projectKey: overrideAnnotation || ownerProjectKey,
    isPortal: portal && portal.length > 0,
    portal,
  };
};
